<app-common-table
	[tableDefinitions]="context.data">
</app-common-table>